import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';

@Injectable()
export class SecuritymenuService {

    constructor(private http: HttpClient, private global: Env) { }

    getAll(): Observable<Permission[]> {

      const url = this.global.access;

      return this.http.get(url).map((res: any) => {
        return res;
      });
    }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/securitymenu.service.ts